export const brand = {
  data: function () {
    return {
      brandConfig: {
        mme: {
          loginOtp_hasBackButton: false,
          loginPass_hasBackButton: false,
          loginMme_hasBackButton: true
        },
        mb: {},
        smart: {
          hasLogo: true,
          hasHeaderExtension: true,
          loginOtp_hasBackButton: false,
          loginPass_hasBackButton: false
        },
        vans: {
          showBrandDescription: true,
          hasHeaderExtension: true,
          loginOtp_hasBackButton: false,
          loginPass_hasBackButton: false
        },
        _default: {
          hasTitlebar: true,
          showRegistrationLink: true,
          hasLogo: false,
          hasHeaderExtension: false,
          loginOtp_hasBackButton: true,
          loginPass_hasBackButton: true,
          loginMme_hasBackButton: true,
          resetPass_hasBackButton: true,
          showPasswordRegField: true
        }
      }
    }
  },
  methods: {
    getConfig: function (key) {
      if (!key) return null
      let value = null

      const brand = this.$store.state.brand

      if (brand && this.brandConfig[brand]) {
        value = this.brandConfig[brand][key]
      }
      if (!value) {
        console.debug('Brand has no dedicated config entry, use default config [key=' + key + ', brand=' + brand + ']')
        value = this.brandConfig._default[key]
      }
      console.debug('Fetched config option [key=' + key + ', brand=' + brand + ', value=' + value + ']')
      return value
    }
  },
  computed: {
    isTitlebarActive: function () {
      return this.getConfig('hasTitlebar') || false
    },
    hasBrandLogo: function () {
      return this.getConfig('hasLogo')
    },
    hasHeaderExtension: function () {
      return this.getConfig('hasHeaderExtension')
    },
    showRegistrationLink: function () {
      return this.getConfig('showRegistrationLink')
    },
    showPasswordRegField: function () {
      return this.getConfig('showPasswordRegField')
    },
    showLoginPassBackButton: function () {
      return this.getConfig('loginPass_hasBackButton')
    },
    showLoginMmeBackButton: function () {
      return this.getConfig('loginMme_hasBackButton')
    }
  }
}
